import { useState, useEffect, useCallback } from "react";
import { applyConsent } from "utils/consent";

const CONSENT_KEY = "doral_cookie_consent";

const DEFAULT_CONSENT = {
    necessary: true,
    analytics: false,
    marketing: false,
    timestamp: null,
    decided: false,
};

export function useCookieConsent() {
    const [consent, setConsent] = useState(() => {
        try {
            const stored = localStorage.getItem(CONSENT_KEY);
            return stored ? JSON.parse(stored) : DEFAULT_CONSENT;
        } catch {
            return DEFAULT_CONSENT;
        }
    });

    const [bannerVisible, setBannerVisible] = useState(false);

    useEffect(() => {
        if (!consent.decided) {
            setBannerVisible(true);
        }
    }, [consent.decided]);



    const saveConsent = useCallback((newConsent) => {
        const updated = {
            ...newConsent,
            necessary: true,
            timestamp: new Date().toISOString(),
            decided: true,
        };
        localStorage.setItem(CONSENT_KEY, JSON.stringify(updated));
        setConsent(updated);
        setBannerVisible(false);
        applyConsent(updated);
    }, []);

    const acceptAll = useCallback(() => {
        saveConsent({ necessary: true, analytics: true, marketing: true });
    }, [saveConsent]);

    const rejectAll = useCallback(() => {
        saveConsent({ necessary: true, analytics: false, marketing: false });
    }, [saveConsent]);

    const openSettings = useCallback(() => {
        setBannerVisible(false);
    }, []);

    const resetConsent = useCallback(() => {
        localStorage.removeItem(CONSENT_KEY);
        setConsent(DEFAULT_CONSENT);
        setBannerVisible(true);
    }, []);

    return {
        consent,
        bannerVisible,
        setBannerVisible,
        saveConsent,
        acceptAll,
        rejectAll,
        openSettings,
        resetConsent,
    };
}
